import * as actionTypes from '../../actionTypes'
import StatusResult from '../../data/StatusResult'

export default function (state = new StatusResult(), action) {
    switch (action.type) {
        case actionTypes.PAYMENT_TERMINAL_DISCONNECT:
        case actionTypes.PAYMENT_TERMINAL_DISCONNECTED:
            return new StatusResult()
        case actionTypes.PAYMENT_TERMINAL_STATUS_CHANGED:
            return action.status
    }

    return state
}
